export default (n) => {
    let ends = ['one', 'few', 'many'];
    if (!window || !window.appCtrl || !window.appCtrl.langCode || window.appCtrl.langCode == 'ru') {
        return ends[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
    } else {
        return ends[n == 0 || n > 1 ? 2 : 0];
    }
};
